import { useEffect } from "react";
import ModalImg from "../assets/image/20211007_120244.jpg";
import axios from "axios";
import Swal from "sweetalert2";

export default function LogInNumber({ ChangeModal, login, SetNumber, number }) {
  useEffect(() => {
    (() => {
      "use strict";

      // Fetch all the forms we want to apply custom Bootstrap validation styles to
      const forms = document.querySelectorAll(".needs-validation");
      // Loop over them and prevent submission
      Array.prototype.slice.call(forms).forEach((form) => {
        form.addEventListener(
          "submit",
          (event) => {
            if (!form.checkValidity()) {
              event.preventDefault();
              event.stopPropagation();
            }
            form.classList.add("was-validated");
          },
          false
        );
      });
    })();
  }, []);

  let SendNumber = (e) => {
    e.preventDefault();
    let formData = new FormData();
    // formData.append("step", "1");
    formData.append("mobile", number);
    axios
      .post("http://mvc.dade24.ir/api/getlogincode", formData)
      .then(({ data }) => {
        if (data.status == 1) {
          ChangeModal(1);
          login(data.data.hashcode);
        } else if (data.status == 0) {
          Swal.fire({
            title: "خطا!",
            text: "لطفا دوباره امتحان کنید",
            type: "error",
            confirmButtonText: "باشه",
          });
        } else if (data.status == -1) {
          Swal.fire({
            title: "خطا!",
            text: "شما مجاز نیستید",
            type: "error",
            confirmButtonText: "باشه",
          });
        }
      })
      .catch((error) => {
        Swal.fire({
          title: "Error!",
          text: "لطفا دوباره امتحان کنید",
          type: "error",
          confirmButtonText: "باشه",
        });
      });
  };

  return (
    <form className="needs-validation" noValidate onSubmit={SendNumber}>
      <div className="modal-body text-center">
        <img src={ModalImg} alt="" width="200px" className="my-4" />
        <h5>ورود یا ثبت نام در جمعه صب</h5>
        <label htmlFor="number" className="mb-4 my-3 text-muted">
          برای ورود به جمعه صب شماره همراه خود را وارد کنید
        </label>
        <input onChange={SetNumber} value={number} type="tel" style={{ height: "50px", borderRadius: "15px", direction: "ltr", fontFamily: "digits" }} id="number" placeholder="09**********" className="form-control w-75 mx-auto" required />
        {/* <input onChange={SetNumber} value={number} placeholder="" id="pass" class="form-control form-phone" type="tel" pattern="[0-9]{10}" required name="mobile" /> */}
        <div className="invalid-feedback text-start" style={{ marginRight: "63px" }}>
          لطفا شماره موبایل خودرا وارد کنید
        </div>
        <label htmlFor="number" className="text-start text-success d-block my-3" style={{ marginRight: "63px" }}>
          شماره موبایل خود را وارد کنید
        </label>
        <button onClick={SendNumber} style={{ height: "50px", borderRadius: "15px" }} className="btn btn-success my-3 w-75">
          ادامه
        </button>
      </div>
    </form>
  );
}
